import React from "react";
import { Zap, TrendingUp, Users, Award, Phone, Shield, Check } from "lucide-react";

// MOCKUP VISUAL - Opción C con diferenciación MOBILSAFE
// Solo para visualización - NO es código de producción

const MockupResultadoParcial = () => {
  // Datos de ejemplo
  const vehiculos = 50;
  const resultadoBase = 31500;
  const rangoMin = Math.round(resultadoBase * 0.85).toLocaleString('es-ES');
  const rangoMax = Math.round(resultadoBase * 1.15).toLocaleString('es-ES');

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-900 via-orange-800 to-red-900 text-white">
      {/* Header */}
      <header className="bg-black/20 backdrop-blur-lg">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center gap-4">
          <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-red-500 rounded-xl flex items-center justify-center shadow-lg">
            <Zap className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-xl font-black text-white">TU INGRESO CAES</h1>
            <p className="text-sm text-orange-200/70">Certificados de Ahorro Energético</p>
          </div>
        </div>
      </header>

      {/* Contenido Principal */}
      <div className="max-w-xl mx-auto px-6 py-8">
        
        {/* ========== SECCIÓN 1: LO NORMAL ========== */}
        <div className="mb-8">
          {/* Badge */}
          <div className="flex justify-center mb-4">
            <div className="inline-flex items-center gap-2 bg-slate-500/30 border border-slate-400/50 px-5 py-2 rounded-full">
              <TrendingUp className="w-4 h-4 text-slate-300" />
              <span className="text-slate-300 font-semibold text-sm">ESTO ES LO NORMAL</span>
            </div>
          </div>

          {/* Texto intro */}
          <p className="text-center text-lg text-orange-100/80 mb-4">
            Tu flota de <span className="font-bold text-white">{vehiculos} vehículos</span> generaría<br/>
            con cualquier gestor CAES:
          </p>

          {/* Rango "normal" */}
          <div className="bg-slate-800/50 border border-slate-500/30 rounded-2xl p-6 text-center">
            <div className="flex items-center justify-center gap-3 mb-2">
              <span className="text-3xl md:text-4xl font-black text-slate-300">{rangoMin} €</span>
              <span className="text-xl text-slate-500">-</span>
              <span className="text-3xl md:text-4xl font-black text-slate-300">{rangoMax} €</span>
            </div>
            <p className="text-slate-400 text-sm">en certificados CAES</p>
          </div>
        </div>

        {/* ========== SECCIÓN 2: MOBILSAFE ES DIFERENTE ========== */}
        <div className="mb-8">
          {/* Badge destacado */}
          <div className="flex justify-center mb-4">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-yellow-500/30 to-orange-500/30 border border-yellow-400/50 px-5 py-2 rounded-full">
              <Award className="w-4 h-4 text-yellow-400" />
              <span className="text-yellow-400 font-bold text-sm">PERO NOSOTROS NO SOMOS LO NORMAL</span>
            </div>
          </div>

          {/* Mensaje de diferenciación */}
          <div className="bg-gradient-to-br from-orange-500/30 to-red-500/30 border-2 border-yellow-400/50 rounded-2xl p-6 text-center">
            <p className="text-orange-100/90 text-lg mb-3">
              Con el método <span className="font-black text-yellow-400">MOBILSAFE</span>,<br/>
              nuestros clientes consiguen hasta un
            </p>
            <p className="text-6xl md:text-7xl font-black text-yellow-400 mb-3">
              +50%
            </p>
            <p className="text-2xl font-bold text-yellow-300">MÁS</p>
          </div>

          {/* Razones */}
          <div className="mt-6 grid grid-cols-1 gap-3">
            <div className="flex items-center gap-3 bg-white/5 rounded-xl p-3">
              <div className="w-10 h-10 bg-yellow-500/20 rounded-lg flex items-center justify-center">
                <Users className="w-5 h-5 text-yellow-400" />
              </div>
              <div>
                <p className="font-bold text-yellow-400 text-sm">No te dejamos solo ni un día</p>
                <p className="text-white/90 text-xs">90 días de acompañamiento real</p>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-white/5 rounded-xl p-3">
              <div className="w-10 h-10 bg-yellow-500/20 rounded-lg flex items-center justify-center">
                <Award className="w-5 h-5 text-yellow-400" />
              </div>
              <div>
                <p className="font-bold text-yellow-400 text-sm">La ficha más difícil, pero la más rentable</p>
                <p className="text-white/90 text-xs">Expertos en la TRA-020</p>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-white/5 rounded-xl p-3">
              <div className="w-10 h-10 bg-yellow-500/20 rounded-lg flex items-center justify-center">
                <TrendingUp className="w-5 h-5 text-yellow-400" />
              </div>
              <div>
                <p className="font-bold text-yellow-400 text-sm">Acuerdos marco con sujetos obligados</p>
                <p className="text-white/90 text-xs">Optimización de la venta</p>
              </div>
            </div>
          </div>
        </div>

        {/* ========== SECCIÓN 3: FORMULARIO ========== */}
        <div className="bg-white/10 backdrop-blur border-2 border-yellow-400/40 rounded-2xl p-6">
          <h3 className="text-xl font-black text-center mb-2">
            ¿Quieres saber cuánto puedes<br/>
            conseguir con <span className="text-yellow-400">MOBILSAFE</span>?
          </h3>
          <p className="text-orange-100/70 text-center mb-5 text-sm">
            Déjanos tus datos y concertamos una reunión<br/>
            para explicarte cómo te generamos más ingresos
          </p>
          
          {/* Formulario */}
          <div className="space-y-3 mb-5">
            <input 
              type="text" 
              placeholder="Nombre de tu empresa *"
              className="w-full px-4 py-3 bg-white/10 border border-orange-400/40 rounded-xl text-white placeholder-white/50"
              readOnly
            />
            <input 
              type="email" 
              placeholder="Tu email *"
              className="w-full px-4 py-3 bg-white/10 border border-orange-400/40 rounded-xl text-white placeholder-white/50"
              readOnly
            />
            <input 
              type="tel" 
              placeholder="Teléfono *"
              className="w-full px-4 py-3 bg-white/10 border border-orange-400/40 rounded-xl text-white placeholder-white/50"
              readOnly
            />
          </div>

          <button className="w-full py-4 bg-gradient-to-r from-yellow-500 to-orange-500 rounded-xl font-black text-lg uppercase tracking-wide shadow-lg shadow-orange-500/30 flex items-center justify-center gap-3">
            <Phone className="w-5 h-5" />
            Quiero mi reunión gratuita
          </button>

          <p className="text-center text-orange-200/50 text-xs mt-4 flex items-center justify-center gap-2">
            <Shield className="w-4 h-4" /> Te contactamos en 24h laborables
          </p>
        </div>

        {/* ========== PREVIEW: QUÉ VE DESPUÉS ========== */}
        <div className="mt-8 p-4 border border-dashed border-orange-500/30 rounded-xl">
          <p className="text-center text-orange-300/60 text-sm mb-4">
            👇 Después de enviar, el usuario vería:
          </p>
          <div className="bg-gradient-to-br from-green-500/20 to-emerald-500/20 border border-green-500/40 rounded-xl p-6 text-center">
            <div className="w-16 h-16 bg-green-500/30 rounded-full flex items-center justify-center mx-auto mb-4">
              <Check className="w-8 h-8 text-green-400" />
            </div>
            <h3 className="text-xl font-black text-green-400 mb-2">¡Solicitud recibida!</h3>
            <p className="text-green-300/80 text-sm mb-4">
              Te contactaremos en las próximas 24h para<br/>
              explicarte cómo conseguir <span className="font-bold text-yellow-400">+50%</span> más<br/>
              en tus certificados CAES
            </p>
            <div className="bg-green-500/20 rounded-lg p-3 inline-block">
              <p className="text-green-300/70 text-xs">Prepara tu reunión con nosotros:</p>
              <p className="text-green-400 font-bold text-sm">📞 Te llamamos pronto</p>
            </div>
          </div>
        </div>

      </div>

      {/* Footer */}
      <footer className="py-6 text-center border-t border-orange-500/20 mt-8">
        <p className="text-orange-200/50 text-sm">© 2026 MOBILSAFE Fleet Technology</p>
      </footer>
    </div>
  );
};

export default MockupResultadoParcial;
